import { render, staticRenderFns } from "./PolicyPage.vue?vue&type=template&id=7b8cbf42&scoped=true"
import script from "./PolicyPage.vue?vue&type=script&lang=js"
export * from "./PolicyPage.vue?vue&type=script&lang=js"
import style0 from "./PolicyPage.vue?vue&type=style&index=0&id=7b8cbf42&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b8cbf42",
  null
  
)

export default component.exports